import React from 'react';

import SignIn from 'components/sign-in/signin.component';
import ScrollToTop from 'hooks/useScrollToTop';

import { MotionRouteContainer } from 'components/common/MotionRouteContainer';
import { routeContainerVariants } from 'theme/motion.variants';

const signinPage = () => {
  return (
    <MotionRouteContainer
      variants={routeContainerVariants}
      initial="hidden"
      animate="visible"
      exit="exit"
    >
      <ScrollToTop />
      <SignIn />
    </MotionRouteContainer>
  );
};

export default signinPage;
